// Cancelar assinatura: confirmação com a data em que o acesso termina
// (cycleEnd). O backend cancela no MP, cancela as faturas abertas e mantém
// o acesso até o fim do ciclo pago.
import React, { useState } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";

import AerosDialog from "../AerosDialog";
import ManageFooter from "./ManageFooter";
import Notice from "./Notice";
import useSubscription from "../../hooks/useSubscription";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  body: { fontSize: 13.5, lineHeight: 1.6, color: theme.palette.text.primary, margin: 0 },
}));

const CancelDialog = ({ open, onClose, subscription, planName, onDone }) => {
  const classes = useStyles();
  const { patchMe } = useSubscription();
  const [saving, setSaving] = useState(false);
  const date = subscription?.cycleEnd
    ? moment(subscription.cycleEnd).format("DD/MM/YYYY")
    : "—";

  const handleConfirm = async () => {
    setSaving(true);
    try {
      await patchMe({ action: "cancel" });
      onDone(i18n.t("subscription.manage.canceled", { date }));
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AerosDialog
      open={open}
      onClose={onClose}
      title={i18n.t("subscription.manage.cancelTitle")}
      subtitle={planName}
      width={480}
      loading={saving}
      footer={
        <ManageFooter
          cancelLabel={i18n.t("subscription.manage.cancelKeep")}
          onCancel={onClose}
          submitLabel={i18n.t("subscription.manage.cancelConfirm")}
          onSubmit={handleConfirm}
          loading={saving}
          danger
        />
      }
    >
      <p className={classes.body}>{i18n.t("subscription.manage.cancelBody", { date })}</p>
      <Notice tone="warn">{i18n.t("subscription.manage.cancelInvoices")}</Notice>
    </AerosDialog>
  );
};

export default CancelDialog;
